/* eslint-disable max-len */
import BoneQuestion from 'images/coin-pages/questions/bone.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const bonePage: ICoinPageData = {
  title: 'coin_167',
  description: 'coin_168',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Bone (BONE)' }) }} />
  ),
  questionsBlock: {
    image: BoneQuestion,
    questions: [
      {
        title: 'coin_169',
        answer: 'coin_170',
      },
      {
        title: 'coin_171',
        answer: 'coin_172',
      },
      {
        title: 'coin_173',
        answer: 'coin_174',
      },
      {
        title: 'coin_175',
        answer: 'coin_176',
      },
      {
        title: 'coin_177',
        answer: 'coin_178',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Bone (BONE)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_179',
        text: ['coin_183'],
      },
      {
        title: 'coin_180',
        text: ['coin_184'],
      },
      {
        title: 'coin_181',
        text: ['coin_185', 'coin_186', 'coin_187', 'coin_188', 'coin_189'],
      },
      {
        title: 'coin_182',
        text: ['coin_190', 'coin_191', 'coin_192', 'coin_193', 'coin_194'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/bone-crypto-all-you-need-to-know/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/03/BONENANO.png',
        imageAlt: 'BONE Crypto loans – All You Need to Know',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
